<script setup>
import { RouterView, useRoute } from 'vue-router'
import { Toaster } from 'vue-sonner'
</script>

<template>
  <RouterView />
  <Toaster position="top-right" richColors closeButton />
</template>

<style scoped></style>
